import React from 'react';
import './OurPlatformIntro.css';

import introImg from 'url:../../assets-optimized/redesign/ourPlatform/intro_our_platform.jpg';
import introImgWebp from 'url:../../assets-optimized/redesign/ourPlatform/intro_our_platform.webp';
import introImgAvif from 'url:../../assets-optimized/redesign/ourPlatform/intro_our_platform.avif';
import introImgMobile from 'url:../../assets-optimized/redesign/ourPlatform/intro_our_platform_mobile.jpg';
import introImgMobileWebp from 'url:../../assets-optimized/redesign/ourPlatform/intro_our_platform_mobile.webp';
import introImgMobileAvif from 'url:../../assets-optimized/redesign/ourPlatform/intro_our_platform_mobile.avif';

export default function OurPlatformIntro() {
  const handleScrollDown = () => {
    const next = document.getElementById('our-platform-intro')?.nextElementSibling;
    if (next) {
      next.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='our-platform-intro' id='our-platform-intro'>
      <div className='opi-row'>
        <div className='opi-left'>
          <h1 className='opi-title'>Travel moves people</h1>
          <div className='opi-bullet'>
            <span className='opi-bullet-dot' aria-hidden='true'></span>
            We understand the journey to every choice
          </div>
        </div>
        <div className='opi-right'>
          <picture>
            <source media='(max-width: 768px)' srcSet={introImgMobileAvif} type='image/avif' />
            <source media='(max-width: 768px)' srcSet={introImgMobileWebp} type='image/webp' />
            <source media='(max-width: 768px)' srcSet={introImgMobile} />
            <source srcSet={introImgAvif} type='image/avif' />
            <source srcSet={introImgWebp} type='image/webp' />
            <img
              src={introImg}
              alt='Traveler leaping by an infinity pool at sunset'
              className='opi-image'
            />
          </picture>
        </div>
      </div>
      <button className='opi-scroll-btn' onClick={handleScrollDown} aria-label='Scroll down'>
        <svg
          width='57'
          height='57'
          viewBox='0 0 57 57'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_1786_4114)'>
            <path
              d='M27.5836 12.9609L27.3965 42.127'
              stroke='#171717'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12.2051 27.5732L27.3942 42.9585L43.7094 26.8514'
              stroke='#171717'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_1786_4114'>
              <rect
                x='28.2852'
                width='40'
                height='40'
                rx='20'
                transform='rotate(45 28.2852 0)'
                fill='white'
              />
            </clipPath>
          </defs>
        </svg>
      </button>
    </section>
  );
}
